import FileInput from './container'

export default FileInput
